// IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках — «в форме меню если зажать Alt — то виден tooltip. добавь в него командную панель
// с кнопками (см. скрин: id записи, копировать ссылку, открыть в новой вкладке). сделай то же во всех tooltip ссылочных элементов»;
// дополнение: те же подсказки с панелью кнопок — на рейле страниц и в списке рабочих областей; кнопка «вставить» у элементов-списков). — IE 2026 11 02 / ODOO-349799 (workspace-wording)
//
// Как устроено:
// - tipActions_html(actions) — блок <div class="tip-actions"> с кнопками-иконками: у кнопки data-tip-act (действие), data-tip-arg (JSON аргумента,
//   экранирован), title (подпись — стандартная подсказка браузера), внутри <i class="pi …">. Блок ДОПИСЫВАЕТСЯ к контенту подсказки
//   (store.tooltip_html / tipHtml панели / cellTooltip_html грида), сам контент подсказки не меняется;
// - клики: ОДИН делегированный слушатель на document (capture, ставится в install из App.vue) — клик по [data-tip-act] внутри .wj-tooltip →
//   store.tipAction_run(act, arg) (открыть запись / ссылка в буфер / новая вкладка / настройки страницы / выполнить пункт / копировать текст /
//   вставить строки), подсказка прячется, панель-меню (MenuPanel) получает событие tip-action и закрывается, кроме копирования. Аргумент либо
//   описывает цель (kind: record | page | pagewidget | workspace | text | paste), либо несёт cb — токен зарегистрированного замыкания
//   (tipActions_bind: пункты меню, ячейки грида, поля форм — там нужен контекст компонента);
// - подсказка с кнопками ОСТАЁТСЯ, пока курсор над ней: при зажатом Alt / дожитии после Alt — механика altTooltip (как раньше), а в режиме
//   «Show tooltips» штатное скрытие wijmo по уходу курсора (_checkBoundsAndHide: курсор вне элемента И вне подсказки) для подсказок с блоком
//   действий откладывается на паузу fe.data.tooltipActionsHoldMs (600 мс; за это время курсор проходит зазор до подсказки) — вернулся на
//   подсказку / элемент — скрытие отменяется;
// - выключатель: настройка базы fe.ux.tooltipActions (по умолчанию включено; false — прежние подсказки без кнопок); счётчики — window.tipActions.stats;
// - общие строители подсказок (одна подсказка у панели страниц и у рейла страниц): pageTip_fn / pageGroupTip_fn / workspaceTip_fn /
//   categoryTip_fn — формат store.tooltip_html (строки «Ключ: значение»), значения — текст, без formatCount стора (числовой id «1234567»
//   стал бы «1.2M»); строки подсказки страницы = строкам пункта панели страниц (Menu item / Group / Page number / Command / ID).
import { Tooltip } from '@mescius/wijmo'
import { t } from '@/i18n'
import altTooltip from './altTooltip'
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: строки объяснения в подсказках рейла и списка столов (способ 2 ядра: строки дописываются к прежним строкам
// подсказки, кнопки-действия остаются; ключи — utils/uiHelp/topbarNav.js; объяснение самой записи — поставщики записей ядра, точка расширения R2)
import { uiHelp_rowsHtml, uiHelp_recordRowsHtml, uiHelp_enabled } from './uiHelp.js'
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: «Edit description» в подсказках рейла и списка столов (админ; utils/recordHelp.js)
import recordHelp from './recordHelp.js'
// IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): кнопки «Text colour» / «Background colour» у пунктов-записей и плиток рейла, полоса образцов внутри подсказки (utils/tipFormat.js)
import tipFormat from './tipFormat.js'
// IE 2026 09 27 / ODOO-341407 (заказ Игоря 27.09: «в tooltip если язык не eng то дополнительно показывай название на англ»): английское имя рядом с переведённым в строках названия
import { tipEn_name, tipEn_html } from './tipEnName.js'
import { menuTipPreview_block, menuTipPreview_workspace } from './menuTipPreview.js'   // IE 2026 10 04 / ODOO-345046 (заказ Игоря: превью в Alt-подсказке пунктов меню): превью стола (его страницы по умолчанию) в подсказке
import { settingsPage_isTemp } from './settingsPage.js'   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц)

export const escHtml = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')

// подписи и значки действий по умолчанию (подпись — в момент сборки, на языке интерфейса)
export const ACT_DEFAULTS = {
    open: { icon: 'pi-arrow-right', title: () => t('Open record') },
    copy: { icon: 'pi-copy', title: () => t('Copy to clipboard') },
    newtab: { icon: 'pi-external-link', title: () => t('Open record in new tab') },
    settings: { icon: 'pi-cog', title: () => t('Page settings') },
    run: { icon: 'pi-play', title: () => t('Run') },
    copytext: { icon: 'pi-copy', title: () => t('Copy') },
    paste: { icon: 'pi-clipboard', title: () => t('Paste rows (JSON)') },
    fmtcolor: { icon: 'pi-pencil', title: () => t('Text colour') },   // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки)
    fmtbg: { icon: 'pi-palette', title: () => t('Background colour') },
}

// классы значка: 'pi pi-copy' / 'pi-copy' / 'pi ie-ico-…' → 'pi <глифы>' (только глифы pi-* / ie-ico-*)
export function iconClass(icon, fallback = 'pi-circle') {
    const parts = String(icon || '').split(/\s+/).filter(c => /^(pi-[\w-]+|ie-ico-[\w-]+)$/.test(c))
    return 'pi ' + (parts.length ? parts.join(' ') : fallback)
}

// блок кнопок; actions: [{ act, title?, icon?, arg? }] — пустой список / выключатель → ''
export function tipActions_html(actions, opts = {}) {
    if (opts.enabled === false) return ''
    const list = (actions || []).filter(a => a && a.act)
    if (!list.length) return ''
    const btns = list.map(a => {
        const d = ACT_DEFAULTS[a.act] || {}
        const title = a.title || (d.title ? d.title() : a.act)
        const arg = (a.arg === undefined || a.arg === null) ? '' : JSON.stringify(a.arg)
        const inner = a.glyph ? String(a.glyph) : `<i class="${escHtml(iconClass(a.icon || d.icon))}"></i>`   // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): glyph — своя разметка значка (буква «A» кнопки цвета текста)
        // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице) · p206b: недоступная кнопка (a.disabled — причина текстом) — класс tip-btn-disabled, aria-disabled,
        // подпись «название — причина»; клик по ней tipActions.onClick гасит
        const dis = !!a.disabled
        const full = (dis && typeof a.disabled === 'string') ? `${title} — ${a.disabled}` : title
        return `<button type="button" tabindex="-1" class="tip-btn tip-btn-${escHtml(a.act)}${dis ? ' tip-btn-disabled' : ''}" data-tip-act="${escHtml(a.act)}"${dis ? ' aria-disabled="true"' : ''}${arg ? ` data-tip-arg="${escHtml(arg)}"` : ''} title="${escHtml(full)}">${inner}</button>`
    })
    return `<div class="tip-actions">${btns.join('')}</div>`
}

export function tipActions_parseArg(str) {
    if (str === null || str === undefined || str === '') return null
    try { const v = JSON.parse(String(str)); return (v && typeof v === 'object') ? v : null } catch (e) { return null }
}

// строки подсказки «Ключ: значение» в формате store.tooltip_html (ключи и значения — текст, экранируются здесь); header — готовый HTML
// IE 2026 09 27 / ODOO-341407: en — { «Подпись»: английское имя } — дописывается к значению строки приглушённым (« · Filters», utils/tipEnName.js)
export function tipRows_html(params, header = '', en = null) {
    let html = header || ''
    for (const key of Object.keys(params || {})) {
        const value = params[key]
        if (value === undefined || value === null || value === '') continue
        html += `${html ? '<br>' : ''}<b class='tooltip-header'>${escHtml(key)}:</b> <b class='tooltip-text'> ${escHtml(value)}${en && en[key] ? tipEn_html(en[key]) : ''}</b>`   // IE 2026 09 27 / ODOO-341407
    }
    return html
}

// ---- реестр замыканий: кнопка несёт токен (arg.cb), действие выполняет компонент (контекст: строка грида, поле формы, пункт панели) ----
const _cbs = new Map()
let _seq = 0
export const CB_MAX = 500
export function tipActions_bind(fn, key = '') {
    const token = key ? 'k:' + key : 'n:' + (++_seq)
    if (_cbs.has(token)) _cbs.delete(token)   // самый свежий — в конец (вытесняются самые старые)
    _cbs.set(token, fn)
    while (_cbs.size > CB_MAX) _cbs.delete(_cbs.keys().next().value)
    return token
}
export function tipActions_callback(token) { return (token && _cbs.get(token)) || null }
export function tipActions_cbCount() { return _cbs.size }

// ---- наборы кнопок ----
// запись: открыть / ссылка в буфер / открыть в новой вкладке; arg — { kind: 'record', id, segment, title } либо { cb }
export function recordActions(arg, opts = {}) {
    return [
        { act: 'open', title: opts.openTitle || t('Open record'), icon: opts.icon || 'pi-arrow-right', arg },
        { act: 'copy', title: t('Copy to clipboard'), icon: 'pi-copy', arg },
        { act: 'newtab', title: t('Open record in new tab'), icon: 'pi-external-link', arg },
    ]
}
export function pasteButton(arg) { return { act: 'paste', title: t('Paste rows (JSON)'), icon: 'pi-clipboard', arg } }
// страница стола: новая вкладка / ссылка / настройки (запись страницы) [+ вставка строк в список страниц стола]
// IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице) · p206b: opts.temp — причины недоступности (pageTempReasons): у ВРЕМЕННОЙ страницы кнопки
// показываются недоступными (a.disabled = причина текстом → приглушена, aria-disabled, клик игнорируется, подпись «название — причина»)
export function pageActions(arg, opts = {}) {
    const tr = opts.temp || null
    const out = [
        { act: 'newtab', title: t('Open in new tab'), icon: 'pi-external-link', arg, ...(tr ? { disabled: tr.link } : {}) },
        { act: 'copy', title: t('Copy link'), icon: 'pi-copy', arg, ...(tr ? { disabled: tr.link } : {}) },
        { act: 'settings', title: t('Page settings'), icon: 'pi-cog', arg, ...(tr ? { disabled: tr.record } : {}) },
    ]
    if (opts.paste !== false) out.push({ ...pasteButton({ kind: 'paste', target: 'page', workspace: arg.workspace, page: arg.page }), ...(tr ? { disabled: tr.list } : {}) })
    return out
}
// IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице) · p206b: ВРЕМЕННАЯ страница (плитка «+» рейла; store.page_isTemp — записи PAGE и строки в списке
// страниц стола нет) → причины недоступности кнопок её подсказки: настройки — записи нет; новая вкладка / ссылка — страница живёт только в этой вкладке,
// ссылка на неё в другой вкладке никуда не ведёт; вставка / оформление — строки страницы в списке страниц стола нет. null — обычная страница или
// выключатель fe.ux.tempPagePlusSaves=false (как было)
export function pageTempReasons(store, workspace, pageId) {
    try {
        if (!store || typeof store.page_isTemp !== 'function' || !store.page_isTemp(workspace, pageId)) return null
        if (typeof store.tempPagePlus_on === 'function' && !store.tempPagePlus_on()) return null
    } catch (e) { return null }
    // IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц): временная страница настроек стола (клон шаблона бэка из меню задач) — своя причина: записи страницы в столе нет,
    // в списке страниц её нет; ссылка на неё работает (адрес …&page=page-settings открывает её снова) — новая вкладка / ссылка доступны
    try {
        if (settingsPage_isTemp(store.WORKSPACES?.[workspace], pageId)) return {
            record: t('This page opens from the tasks menu and is not in the page list of the workspace — it has no page record of its own: to keep it as a page, save it with «+», «✓» or «Save as new page»'),
            link: '',
            list: t('This page opens from the tasks menu and is not in the page list of the workspace: to keep it as a page, save it with «+», «✓» or «Save as new page»'),
        }
    } catch (e) { /* обычная временная страница */ }
    return {
        record: t('This page is new and not saved yet — it has no record to open: save it first («+», «✓» or «Save as new page»)'),
        link: t('This page is new and not saved yet — it exists only in this tab, a link to it opens nothing elsewhere: save it first («+», «✓» or «Save as new page»)'),
        list: t('This page is new and not saved yet — it is not in the page list of the workspace: save it first («+», «✓» or «Save as new page»)'),
    }
}
// виджет под страницей (панель страниц): новая вкладка / ссылка (URL страницы + &widgets=) / запись виджета [+ вставка строк в список виджетов страницы]
export function pageWidgetActions(arg, opts = {}) {
    const out = [
        { act: 'newtab', title: t('Open in new tab'), icon: 'pi-external-link', arg },
        { act: 'copy', title: t('Copy link'), icon: 'pi-copy', arg },
        { act: 'open', title: t('Open record'), icon: opts.icon || 'pi-file', arg },
    ]
    if (opts.paste !== false) out.push(pasteButton({ kind: 'paste', target: 'pagewidget', workspace: arg.workspace, page: arg.page, widget: arg.widget }))
    return out
}
// стол: новая вкладка / ссылка / запись стола
export function workspaceActions(arg) {
    return [
        { act: 'newtab', title: t('Open in new tab'), icon: 'pi-external-link', arg },
        { act: 'copy', title: t('Copy link'), icon: 'pi-copy', arg },
        { act: 'open', title: t('Open record'), icon: 'pi-desktop', arg },
    ]
}
// пункт-команда: выполнить (замыкание run) / скопировать «название · хоткей»
export function commandActions({ run, text } = {}) {
    const out = []
    if (run) out.push({ act: 'run', title: t('Run'), icon: 'pi-play', arg: run })
    if (text) out.push({ act: 'copytext', title: t('Copy'), icon: 'pi-copy', arg: { kind: 'text', text } })
    return out
}

// ---- пункты панелей-меню (сырые строки MenuPanel): вид пункта по его полям ----
// _page + _widget — виджет под страницей (панель страниц), _page — страница, _open — запись (Tasks panel), иначе команда (панель пользователя,
// ≡ виджета / таблицы, меню страницы); папка без команды — ничего
export function menuRawKind(r) {
    if (!r) return ''
    if (r._page && r._widget) return 'pagewidget'
    if (r._page) return 'page'
    if (r._open && r._open.id) return 'record'
    const a = r.action
    const fromAction = a && (typeof a === 'string' || (typeof a === 'object' && (a.command || a.backend_command)))
    if (r._rightAction || r.command || r.method || fromAction || r.widget || (r.node && r.node.value && !(r.attrs && r.attrs.length))) return 'command'
    return ''
}
// opts: { workspace, title, icon, link (пункт — ссылка), run (токен замыкания «выполнить»), paste (false — без кнопки вставки) }
function _menuItemActions(r, opts = {}) {
    const kind = menuRawKind(r)
    const ws = String(opts.workspace || '')
    const title = String(opts.title || r.titleAction || r.title || r.tooltip || r.node?.valueStr || '')
    if (kind === 'pagewidget') {
        const arg = { kind: 'pagewidget', workspace: ws, page: String(r._page), widget: String(r._widget), segment: String(r._segment || ''), title }
        return pageWidgetActions(arg, { icon: opts.icon, paste: opts.paste !== false })
    }
    if (kind === 'page') return pageActions({ kind: 'page', workspace: ws, page: String(r._page), title }, { paste: opts.paste !== false, temp: pageTempReasons(tipActions.store, ws, String(r._page)) })   // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице) · p206b
    if (kind === 'record') {
        const arg = { kind: 'record', id: String(r._open.id), segment: String(r._open.segment || ''), title: String(r._open.title || title) }
        const out = recordActions(arg, { icon: opts.icon })
        if (r._paste && opts.paste !== false) out.push(pasteButton({ kind: 'paste', ...r._paste }))
        return out
    }
    if (kind === 'command' && opts.link !== false) {
        const text = title + (r.hotkey ? ' · ' + r.hotkey : '')
        return commandActions({ run: opts.run ? { cb: opts.run } : null, text })
    }
    return []
}

// IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): opts.extra — кнопки, добавляемые в конец ряда (форматирование строки пункта — MenuPanel._itemActions → tipFormat.menuActions)
export function menuItemActions(r, opts = {}) {
    const out = _menuItemActions(r, opts)
    if (Array.isArray(opts.extra) && opts.extra.length) {
        // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице) · p206b: у временной страницы оформление строки (цвет / фон) недоступно — строки в списке страниц стола нет
        const tr = menuRawKind(r) === 'page' ? pageTempReasons(tipActions.store, String(opts.workspace || ''), String(r._page)) : null
        out.push(...(tr ? opts.extra.map(a => ({ ...a, disabled: tr.list })) : opts.extra))
    }
    return out
}

// ---- общие строители подсказок (панель страниц в шапке = рейл страниц; список столов) ----
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: поля объяснения по виду строки; выключатель fe.ux.uiHelp — строк нет, как было
const RAIL_PAGE_ROWS = ['what', 'why', 'click', 'now', 'affects', 'stored']
const RAIL_GROUP_ROWS = ['what', 'why', 'click', 'now', 'affects', 'stored']
const WS_ROWS = ['what', 'click', 'now', 'affects']
const _help = (key, opts, fields) => (uiHelp_enabled() ? uiHelp_rowsHtml(key, opts || {}, fields) : '')
const _recHelp = (id, segment, ctx) => uiHelp_recordRowsHtml(id, segment || '', ctx || {})
const _recEdit = (id, segment, title) => recordHelp.editHtml({ id, segment: segment || '', title: title || '' })   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: под строками записи, перед кнопками
const _wsPages = (store, workspace) => Object.values(store?.WORKSPACES?.[workspace]?.PAGES || {}).filter(P => P && P.node?.value)
const _pageTitle = (P) => String(P?.node?.valueStr || P?.title || P?.node?.value || '')
const _on = (store) => !store || typeof store.tipActions_on !== 'function' || store.tipActions_on()
// IE 2026 09 27 / ODOO-341407 (заказ Игоря 27.09: английское имя в подсказке): английское имя группы страниц — её ключ (бэк: key = исходный узел группы, title = словарь
// по нему; relocalize.js переводит title от key); служебный ключ group-N — не имя
const _groupKeyEn = (g) => { const k = String(g?.key || ''); return (k && !/^group-\d+$/.test(k)) ? k : '' }
// id всех страниц стола / всех столов списка — пачка одного запроса catalog_titles (langs='all') при первой подсказке без английского имени
const _wsPageIds = (store, workspace) => _wsPages(store, workspace).map(P => String(P.node.value))
const _wsIds = (store) => { const out = []; for (const c of (store?.menuTree_model || [])) for (const it of [c, ...(c?.items || [])]) { const id = workspaceIdOf(it); if (id && !out.includes(id)) out.push(id) } return out.slice(0, 300) }
// английское имя категории списка столов: пункт модели (menu_push) несёт только подпись — узел меню бэка (store.menuTree) с этой подписью несёт бэкап node.valueStr_en
function _catEn(store, label) {
    const want = String(label || '')
    const walk = (nodes, d) => {
        for (const n of nodes || []) {
            if (!n || typeof n !== 'object') continue
            if (n.node && n.node.valueStr === want) return n
            if (d < 3) { const r = walk(n.attrs, d + 1); if (r) return r }
        }
        return null
    }
    let raw = null
    try { raw = want ? walk(store?.menuTree, 0) : null } catch (e) { raw = null }
    return tipEn_name(want, { raw, store, ui: true })
}

// страница: те же строки, что у пункта панели страниц (MenuPanel._itemTip): шапка — свой tooltip страницы, когда он не повторяет название;
// Menu item / Group (группа страницы либо «Pages» — так панель группирует страницы вне групп) / Page number / Command / ID; кнопки pageActions
export function pageTip_fn(store, workspace, pageId) {
    return () => {
        const WS = store?.WORKSPACES?.[workspace]
        const P = WS?.PAGES?.[pageId]
        if (!P) return ''
        const title = _pageTitle(P)
        const tipText = String(P.tooltip || '').trim()
        const header = (tipText && tipText !== title) ? escHtml(tipText) : ''
        const params = {}, en = {}
        params[t('Menu item')] = title
        params[t('Group')] = String(P.group?.title || P.group?.key || t('Pages'))
        // IE 2026 09 27 / ODOO-341407 (заказ Игоря 27.09: английское имя в подсказке): страница — запись по id (catalog_titles, пачка — все страницы стола), группа — её ключ / 'Pages'
        en[t('Menu item')] = tipEn_name(title, { raw: P, id: pageId, store, ids: () => _wsPageIds(store, workspace) })
        en[t('Group')] = tipEn_name(params[t('Group')], { en: P.group ? _groupKeyEn(P.group) : 'Pages', store, ui: true })
        const num = store.pageRail_num ? store.pageRail_num(workspace, pageId) : null
        if (num !== null && num !== undefined) params[t('Page number')] = String(num)
        params[t('Command')] = 'page_open'
        params[t('ID')] = String(pageId)
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: объяснение плитки (что это, клик, Now: текущая страница стола или нет, на что влияет,
        // где хранится) и объяснение самой записи страницы от поставщиков записей — между строками и кнопками
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U2: служебная плитка «New» (создаёт временную нумерованную страницу, Page.vue:706) объясняется
        // своим ключом topbar.rail.pageNew, а не topbar.rail.page (тот же v-wjTooltipFn, тот же ряд полей)
        // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице) · p206b: плитка ВРЕМЕННОЙ страницы — своё объяснение (topbar.rail.pageTemp), без объяснения / описания
        // записи (её нет); кнопки подсказки недоступны с причиной (pageTempReasons)
        const temp = pageId === 'page-new' ? null : pageTempReasons(store, workspace, pageId)
        const helpKey = pageId === 'page-new' ? 'topbar.rail.pageNew' : (temp ? 'topbar.rail.pageTemp' : 'topbar.rail.page')
        const help = _help(helpKey, { state: WS?.active_page === pageId ? 'current' : 'other' }, RAIL_PAGE_ROWS)
            + (temp ? '' : _recHelp(pageId, P.node?.relation_segment, { kind: 'page', workspace: String(workspace) })
            + _recEdit(pageId, P.node?.relation_segment, title))   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2
        // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): + кнопки цвета текста / фона плитки (админ) — те же, что у пункта панели страниц
        const fmt = tipFormat.actions(tipFormat.pageTarget(workspace, pageId)).map(a => (temp ? { ...a, disabled: temp.list } : a))   // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице) · p206b
        return tipRows_html(params, header, en) + help + tipActions_html(pageActions({ kind: 'page', workspace: String(workspace), page: String(pageId), title }, { temp }).concat(fmt), { enabled: _on(store) })   // IE 2026 09 27 / ODOO-341407: + en
    }
}
// группа страниц рейла: Group / Items (число страниц группы) — без кнопок, как у заголовка группы панели
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: opts.state() → 'collapsed' | 'expanded' (свёртка живёт в компоненте рейла — Page.vue groupsCollapsed)
export function pageGroupTip_fn(store, workspace, groupKey, opts = {}) {
    return () => {
        const pages = _wsPages(store, workspace).filter(P => P.group?.key === groupKey)
        if (!pages.length) return ''
        const g = pages[0]?.group
        const title = String(g?.title || groupKey || '')
        if (!title) return ''
        const tipText = String(g?.tooltip || '').trim()
        const params = {}
        params[t('Group')] = title
        params[t('Items')] = String(pages.length)
        const en = { [t('Group')]: tipEn_name(title, { en: _groupKeyEn(g), store, ui: true }) }   // IE 2026 09 27 / ODOO-341407 (заказ Игоря 27.09: английское имя в подсказке)
        let state = null
        try { state = typeof opts.state === 'function' ? opts.state() : null } catch (e) { state = null }
        return tipRows_html(params, (tipText && tipText !== title) ? escHtml(tipText) : '', en) + _help('topbar.rail.group', { state }, RAIL_GROUP_ROWS)   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1
            + tipActions_html(tipFormat.actions(tipFormat.groupTarget(workspace, groupKey)), { enabled: _on(store) })   // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): кнопки цвета / фона строки группы (админ)
    }
}
// id стола из пункта списка столов: item.workspace (menu_push) либо параметр workspace= маршрута to / url
export function workspaceIdOf(item) {
    if (!item) return ''
    if (item.workspace) return String(item.workspace)
    if (item.to && typeof item.to === 'object' && item.to.query && item.to.query.workspace) return String(item.to.query.workspace)
    const s = typeof item.to === 'string' ? item.to : String(item.url || '')
    const m = /[?&]workspace=([^&#]+)/.exec(s)
    return m ? decodeURIComponent(m[1]) : ''
}
// стол в сайдбаре: Workspace / Category / ID; кнопки — новая вкладка / ссылка / запись стола (только у пункта с id)
export function workspaceTip_fn(store, item, cat) {
    return () => {
        if (!item) return ''
        const params = {}, en = {}
        params[t('Workspace')] = String(item.label || '')
        if (cat && cat.label && cat !== item) params[t('Category')] = String(cat.label)
        const id = workspaceIdOf(item)
        if (id) params[t('ID')] = id
        // IE 2026 09 27 / ODOO-341407 (заказ Игоря 27.09: английское имя в подсказке): стол — открытая запись стола, иначе запись по id (catalog_titles, пачка — все столы списка);
        // категория — бэкап узла меню бэка
        en[t('Workspace')] = id ? tipEn_name(item.label, { record: store?.WORKSPACES?.[id]?.record, id, store, ids: () => _wsIds(store) }) : tipEn_name(item.label, { store, ui: true })
        if (params[t('Category')]) en[t('Category')] = _catEn(store, cat.label)
        // IE 2026 09 25 / ODOO-… (заказ Игоря: бейдж открытых страниц у стола): «Open pages: N — названия» — те же страницы, что считает бейдж строки (store.workspaceOpenPages);
        // при 0 строки нет (как и бейджа); названия — как подписи рейла (PAGE.tooltip → node.valueStr)
        if (id && store?.workspaceOpenPages_on?.()) {
            const pages = store.workspaceOpenPages(id)
            if (pages.length) params[t('Open pages')] = pages.length + ' — ' + pages.map(P => String(P.tooltip || P.node?.valueStr || P.node?.value || '')).join(', ')
        }
        let acts = []
        const segment = id ? String(item.segment || store?.WORKSPACES?.[id]?.record?.segment || '') : ''
        if (id) {
            acts = workspaceActions({ kind: 'workspace', id, segment, title: String(item.label || '') })
        }
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: объяснение строки (Now — открыт ли этот стол сейчас: id стола, иначе название, как подсветка
        // RailMenu.isCurrentWs) и объяснение записи стола от поставщиков записей — между строками и кнопками
        const cur = store?.activeWORKSPACE
        const isCur = !!cur && ((!!id && cur.workspace === id) || (!!item.label && item.label === (cur.record?.title || cur.title)))
        const help = _help('topbar.sidebar.workspace', { state: isCur ? 'current' : 'other' }, WS_ROWS) + (id ? _recHelp(id, segment, { kind: 'workspace' }) + menuTipPreview_block(menuTipPreview_workspace(store, id)) + _recEdit(id, segment, String(item.label || '')) : '')   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: + «Edit description»
        return tipRows_html(params, '', en) + help + tipActions_html(acts, { enabled: _on(store) })   // IE 2026 09 27 / ODOO-341407: + en
    }
}
// категория списка столов (HOME / DATA …): Category / Workspaces — без кнопок
export function categoryTip_fn(cat) {
    return () => {
        if (!cat || !cat.label) return ''
        const params = {}
        params[t('Category')] = String(cat.label)
        params[t('Workspaces')] = String((cat.items || []).length)
        const en = { [t('Category')]: _catEn(tipActions.store, cat.label) }   // IE 2026 09 27 / ODOO-341407 (заказ Игоря 27.09: английское имя в подсказке)
        return tipRows_html(params, '', en) + _help('topbar.sidebar.category', {}, ['what'])   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1
    }
}

// ---- контроллер: клики по кнопкам, удержание подсказки в режиме «Show tooltips», скрытие после действия ----
const tipActions = {
    store: null,
    _installed: false,
    _inst: null,        // инстанс wijmo Tooltip последнего показа (App.vue, обёртка show) — им прячем после действия
    _hideTimer: null,
    stats: { clicks: 0, holds: 0, holdCancels: 0, runs: 0, errors: 0, disabled: 0 },   // disabled — клики по недоступным кнопкам (p206b)
    enabled() {
        try { return this.store?.setting?.('fe.ux.tooltipActions', true) !== false } catch (e) { return true }
    },
    holdMs() {
        try { const v = +this.store?.setting?.('fe.data.tooltipActionsHoldMs', 600); return v >= 0 ? v : 600 } catch (e) { return 600 }
    },
    install(store) {
        this.store = store
        if (this._installed) return
        this._installed = true
        this._onClick = (e) => this.onClick(e)
        document.addEventListener('click', this._onClick, true)
        window.tipActions = this
        tipFormat.install(store)   // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки)
    },
    uninstall() {
        if (!this._installed) return
        this._installed = false
        document.removeEventListener('click', this._onClick, true)
        this._hideLaterCancel()
        tipFormat.uninstall()   // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки)
    },
    // обёртка Tooltip.show (App.vue): помним инстанс — по нему прячем после действия
    shown(inst) { this._inst = inst; this._hideLaterCancel() },
    tipEl() {
        try {
            const el = Tooltip._eTip
            if (el && el.isConnected) return el
            for (const e of document.querySelectorAll('.wj-tooltip')) { const r = e.getBoundingClientRect(); if (r.width > 0 && r.height > 0) return e }
        } catch (e) { /* нет DOM */ }
        return null
    },
    tipHasActions() { const el = this.tipEl(); return !!(el && el.querySelector('.tip-actions, .tip-help-actions')) },   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: и кнопка «Edit description»
    // клик по кнопке внутри подсказки: ДО прочих слушателей документа (панель-меню закрывается по клику мимо — это не «мимо»)
    onClick(e) {
        if (tipFormat.onDocClick(e)) return   // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): клик внутри полосы образцов — образец / назад / применить; подсказка остаётся
        const btn = e.target?.closest?.('.tip-btn[data-tip-act]')
        if (!btn || !btn.closest('.wj-tooltip')) return
        e.preventDefault(); e.stopImmediatePropagation()
        if (btn.getAttribute('aria-disabled') === 'true') { this.stats.disabled++; return }   // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице) · p206b: недоступная кнопка — ничего; подсказка остаётся
        const act = btn.getAttribute('data-tip-act') || ''
        const arg = tipActions_parseArg(btn.getAttribute('data-tip-arg'))
        this.stats.clicks++
        if (tipFormat.isAct(act)) { tipFormat.open(btn, act, arg); return }   // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): ряд кнопок → полоса образцов в самой подсказке (не гаснет)
        this.hideNow()
        this.run(act, arg)
        // панели-меню (MenuPanel) закрываются после действия, кроме копирования — событие, чтобы не тянуть компонент сюда
        try { document.dispatchEvent(new CustomEvent('tip-action', { detail: { act, arg } })) } catch (err) { /* старый браузер */ }
    },
    run(act, arg) {
        this.stats.runs++
        try { return this.store?.tipAction_run?.(act, arg || {}) } catch (err) { this.stats.errors++; if (!this.store?.hide_console) console.warn('tipActions: action failed', act, err) }
        return false
    },
    // спрятать подсказку: доживающую после Alt — через её контроллер (иначе hide() не действует), по зажатому Alt — тоже, прочие — инстансом
    hideNow() {
        this._hideLaterCancel()
        try {
            if (altTooltip._lingerEl) { altTooltip._lingerCancel(true); return }
            if (altTooltip._el && altTooltip.held) { altTooltip._hide(); return }
            const inst = this._inst || altTooltip.tip
            inst?.hide?.()
        } catch (e) { /* уже скрыта */ }
    },
    _hideLaterCancel() {
        if (this._hideTimer) { clearTimeout(this._hideTimer); this._hideTimer = null; this.stats.holdCancels++ }
    },
}

// режим «Show tooltips» (без Alt): wijmo прячет подсказку, когда курсор вне элемента И вне подсказки (mouseleave элемента → mousemove по документу →
// _checkBoundsAndHide). Подсказка с кнопками получает паузу: курсор успевает пройти зазор до кнопок, а уход с подсказки прячет её через holdMs.
// При зажатом Alt и при дожитии после Alt решает контроллер altTooltip (его патч ниже по цепочке)
if (!Tooltip.prototype.__tipActionsPatched) {
    Tooltip.prototype.__tipActionsPatched = true
    const origCheck = Tooltip.prototype._checkBoundsAndHide
    if (typeof origCheck === 'function') {
        Tooltip.prototype._checkBoundsAndHide = function (e, clear) {
            if (tipFormat.active) { tipActions._hideLaterCancel(); return }   // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): полоса образцов открыта — подсказка держится (Show tooltips)
            if (!altTooltip._lingerEl && !altTooltip.held && tipActions.enabled() && tipActions.tipHasActions()) {
                let out = true
                try { out = this._isMouseOutOfTipAndOwner(e) === true || (e && e.type === 'blur') } catch (err) { out = true }
                if (!out) { tipActions._hideLaterCancel(); return }
                // отложенные показы ЭТОГО инстанса (mouseenter соседнего пункта по пути к подсказке — showDelay 400 мс) снимаются сразу, как это делал бы
                // штатный проход (clear): иначе соседняя подсказка заменила бы нашу раньше, чем истечёт пауза удержания
                if (clear) { try { this._clearTimeouts() } catch (err) { /* нет таймеров */ } }
                if (tipActions._hideTimer) return
                tipActions.stats.holds++
                tipActions._hideTimer = setTimeout(() => {
                    tipActions._hideTimer = null
                    try { origCheck.call(this, e, clear) } catch (err) { /* элемент исчез */ }
                }, tipActions.holdMs())
                return
            }
            return origCheck.call(this, e, clear)
        }
    }
    const origHide = Tooltip.prototype.hide
    Tooltip.prototype.hide = function (...args) {
        tipActions._hideLaterCancel()
        const r = origHide.apply(this, args)
        // после скрытия та же подсказка должна показываться снова: дедуп повторных show в обёртке App.vue (altTooltip.lastKey — контент + прямоугольник)
        // иначе держал бы её до показа какой-нибудь другой (курсор вернулся на тот же пункт — подсказки нет)
        try { if (!altTooltip._el && !altTooltip._lingerEl) altTooltip.lastKey = null } catch (e) { /* нет контроллера */ }
        return r
    }
}

export default tipActions
